import { memo } from 'react';

import { FooterWS } from './FooterWS';

export * from './FooterWS';

export default memo(FooterWS);
